var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publisherEl",class:{ publishAudio: _vm.publishAudio, publishVideo: _vm.publishVideo },attrs:{"id":"publisherEl"}},[_c('i',{staticClass:"material-icons"},[_vm._v("mic_off")])])
}
var staticRenderFns = []

export { render, staticRenderFns }